export const country = 'aa[a]'
export const state = 'aa[a]'
export const postalcode = '00000[00]'
export const recipientcode = '000000[0]'
export const phonePrefix = '+0[00]'
export const phone = /^[0-9]*$/
